import { UpgradeTutorialWhiteTextStyle } from "./UpgradeTutorialWhiteTextStyle";

export class UpgradeTutorialGreenTextStyle extends UpgradeTutorialWhiteTextStyle {
    public constructor() {
        super();
        this.fill = [
            "#AAFD09",
            "#16CF15"
        ]
    }
}